import React from "react";
import { colors, radius, shadow } from "./tokens";

// Coquille de tableau partagée — l'en-tête et le conteneur sont communs à tous les modules, le
// contenu des lignes reste propre à chaque page (colonnes très différentes d'un module à l'autre).
export function TableCard({ headers, children }: { headers: string[]; children: React.ReactNode }) {
  return (
    <div style={{ backgroundColor: colors.card, border: `1px solid ${colors.border}`, borderRadius: radius.lg, boxShadow: shadow, overflow: "hidden" }}>
      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ backgroundColor: colors.bg }}>
              {headers.map(h => (
                <th key={h} style={{ textAlign: "left", padding: "12px 16px", fontSize: 11, color: colors.textMuted, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5, whiteSpace: "nowrap" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>{children}</tbody>
        </table>
      </div>
    </div>
  );
}

export const trStyle: React.CSSProperties = { borderTop: `1px solid ${colors.border}` };
export const td: React.CSSProperties = { padding: "14px 16px", fontSize: 13.5, color: colors.text };
export const tdMuted: React.CSSProperties = { ...td, color: colors.textMuted, fontSize: 13 };
